import React, { createContext, useContext, useEffect, useState } from "react";

// Create a new context
const TipContext = createContext();

// Custom hook to use the tip context
export const useTip = () => useContext(TipContext);

// Custom hook to handle storing and retrieving tip number
export const useTipNumber = () => {
    const [tipNumber, setTipNumber] = useState(0);

    useEffect(() => {
        // Retrieve tip number from local storage if available
        const storedTipNumber = localStorage.getItem("tipNumber");
        if (storedTipNumber) {
            setTipNumber(storedTipNumber);
        }
    }, []);

    useEffect(() => {
        // Store tip number in local storage
        localStorage.setItem("tipNumber", tipNumber.toString());
    }, [tipNumber]);

    return [tipNumber, setTipNumber];
};

// Wrap your app with the TipProvider to make the tip context available
export const TipProvider = ({ children }) => {
    const tipState = useTipNumber();

    return <TipContext.Provider value={tipState}>{children}</TipContext.Provider>;
};
